import api from "./apiURL";

export async function getDashboardDetails(timePeriod = 'today') {
  try {
    const response = await api.get(`/api/v1/user/dashboard`, {
      params: { timePeriod }
    });
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function getDashboardPayment(timePeriod = 'today') {
  try {
    const response = await api.get(`api/v1/payment/get`, {
      params: { timePeriod }
    });
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function getAndroidDownloads(timePeriod = 'today') {
  try {
    const response = await api.get(`/api/v1/user/downloads/android`, {
      params: { timePeriod }
    });
    return response.data;
  } catch (error) {
    // Handle the error
    console.error('Error fetching Android downloads:', error);
    return { error: true, data: { android: 0, ios: 0, total: 0 } };
  }
}
